import { useLocation } from 'react-router-dom';

export function useWebview(): {
  shouldHideHeader: () => boolean;
} {
  const location = useLocation();
  const queries = new URLSearchParams(location.search);
  const hideHeader = queries.get('hideHeader') === 'true';
  const showHeader = queries.get('showHeader') === 'true';

  if (hideHeader) {
    sessionStorage.setItem('hideHeader', 'true');
  }

  if (showHeader) {
    sessionStorage.removeItem('hideHeader');
  }

  function shouldHideHeader() {
    const result = sessionStorage.getItem('hideHeader');

    if (result) return true;
    return false;
  }

  return {
    shouldHideHeader
  };
}
